<template>
  <div
    class="language-btns">
    <sTooltip
      v-for="(item) in dictionaryLanguage"
      :key="item.flag"
      :border="false"
      class="mr-2"
      :content="item.name"
      type="white">
      <sButton
        :disabled="curentLanguage === item.flag"
        :rounded="false"
        small
        text
        type="text"
        @click="SetLocale(item.flag)">
        {{ item.label }}
      </sButton>
    </sTooltip>
  </div>
</template>
<script>

export default {
  name: 'iconLanguageComponent',
  data() {
    return {
      curentLanguage: '',
      arrayCountryAndFlag: [],
      dictionaryLanguage: {
        uk: { name: 'Українська', flag: 'uk', label: 'Укр', code: 'uk-UA' },
        en: { name: 'English', flag: 'en', label: 'Eng', code: 'en-US' },
      },
      codes: {
        uk: 'uk-UA' ,
        en: 'en-US' ,
      },
      curlanguage: 'uk'
    }
  },
  computed: {
  },
  watch: {
    curlanguage(newValue, old) {
      newValue, old
    }
  },
  mounted() {
    const curlanguage = sessionStorage.getItem('language') ?? window.config.ui_locales
    this.curentLanguage = this.curlanguage = (curlanguage === 'ru' ? 'uk' : curlanguage)
  },
  methods: {
    //Изменяем локализацию через выбор элемента в списке
    async SetLocale(lang) {
      this.$log( 'change to' , lang, this.$route )

      if ( this.curentLanguage != lang && lang ) {
        let route
        let lang_route = lang == 'uk' ? '' : lang

        sessionStorage.VueAppLanguage = lang
        sessionStorage.language = lang
        sessionStorage.languageCode = this.codes[lang]
        this.$i18n.$setLocaleCookie(lang)

        if ( this.$route.path.includes(`/${this.curentLanguage}/`) ) {
          route = this.$route.path.replace(`/${this.curentLanguage}/`, '/')
        } else {
          route =  '/' + lang_route + this.$route.path
        }
        window.location.href = window.location.href.replace(this.$route.path, route)
      }

    },
    //Установка локализации из параметра в строке url
    SetUpLanguageFromURLParameter() {
      var language = this.$route?.query?.language.toLowerCase()
      this.curentLanguage = language
    },
  },
}
</script>

<style lang="scss">
.language-btns {
  & > .language-btn.v-btn {
    border-radius: 2px;
    &.v-item--active {
      background-color: var(--v-secondary__green_chosen-base) !important;
      &::before {
        opacity: 0 !important;
      }
    }
    &::before {
      background-color: var(--v-secondary__green_chosen-darken1) !important;
    }
    &:hover {
      &::before  {
        opacity: 0.4 !important;
      }

    }
  }
}
</style>
